import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _WarningWrapper;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@instructure/ui-alerts';
import { Button } from '@instructure/ui-buttons';
import { Text } from '@instructure/ui-text';
import { jsx } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/es/format-message';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
export var WarningWrapper = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_WarningWrapper = /*#__PURE__*/function (_Component) {
  function WarningWrapper() {
    var _this;
    _classCallCheck(this, WarningWrapper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, WarningWrapper, [].concat(args));
    _defineProperty(_this, "focusRef", null);
    _defineProperty(_this, "setFocusRef", function (element) {
      _this.focusRef = element;
    });
    return _this;
  }
  _inherits(WarningWrapper, _Component);
  return _createClass(WarningWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.focusRef) this.focusRef.focus();
    }
  }, {
    key: "renderMessage",
    value: function renderMessage() {
      if (!this.props.showAlert) return;
      return this.renderAlert();
    }
  }, {
    key: "renderActionButtons",
    value: function renderActionButtons() {
      if (this.props.hideActions) return;
      return jsx("div", null, jsx(Button, {
        size: "small",
        onClick: this.props.cancelActionCallback,
        ref: this.setFocusRef
      }, this.props.cancelActionText), jsx(Button, {
        size: "small",
        margin: "x-small",
        color: "primary",
        onClick: this.props.defaultActionCallback
      }, this.props.defaultActionText));
    }
  }, {
    key: "renderDescription",
    value: function renderDescription() {
      return jsx("div", null, jsx(Text, {
        color: "primary"
      }, this.props.description));
    }
  }, {
    key: "renderAlertContent",
    value: function renderAlertContent() {
      return jsx("div", {
        css: this.props.styles.alertContent
      }, this.renderDescription(), this.renderActionButtons());
    }
  }, {
    key: "renderAlert",
    value: function renderAlert() {
      return jsx("div", {
        css: this.props.styles.alert
      }, jsx(Alert, {
        variant: this.props.alertType
      }, this.renderAlertContent()));
    }
  }, {
    key: "renderDisableOverlay",
    value: function renderDisableOverlay() {
      if (!this.props.disableChildren) return;
      return jsx("div", {
        css: this.props.styles.disabledChildren,
        "data-testid": "disabled-children"
      });
    }
  }, {
    key: "render",
    value: function render() {
      return jsx("div", {
        css: this.props.styles.container
      }, this.renderMessage(), this.renderDisableOverlay(), this.props.children);
    }
  }]);
}(Component), _defineProperty(_WarningWrapper, "displayName", 'WarningWrapper'), _defineProperty(_WarningWrapper, "componentId", "Quizzes".concat(_WarningWrapper.displayName)), _defineProperty(_WarningWrapper, "propTypes", {
  alertType: PropTypes.oneOf(['info', 'success', 'warning', 'error']),
  cancelActionCallback: PropTypes.func,
  cancelActionText: PropTypes.string,
  children: PropTypes.node.isRequired,
  defaultActionCallback: PropTypes.func,
  defaultActionText: PropTypes.string,
  description: PropTypes.node,
  disableChildren: PropTypes.bool,
  hideActions: PropTypes.bool,
  showAlert: PropTypes.bool,
  styles: PropTypes.object
}), _defineProperty(_WarningWrapper, "defaultProps", {
  alertType: 'info',
  cancelActionCallback: void 0,
  cancelActionText: t('Cancel'),
  defaultActionCallback: void 0,
  defaultActionText: t('Submit'),
  description: void 0,
  disableChildren: false,
  hideActions: void 0,
  showAlert: true
}), _WarningWrapper)) || _class);
export default WarningWrapper;